module.exports = __webpack_public_path__ + "static/media/ChakraRelationshipSeries.a38270ba.jpg";